import { SurveyInterstitialRoute } from '../surveyRoutes';

export type InterstitialContent = {
  heading: string;
  additionalInfo: string | null;
  interstitialContinueButtonTestId: `survey-${string}-interstitial-continue`;
};

export const INTERSTITIAL_CONTENT: Record<SurveyInterstitialRoute, InterstitialContent> = {
  [SurveyInterstitialRoute.DEMOGRAPHICS]: {
    heading: "First, let's start with some questions about you.",
    additionalInfo: null,
    interstitialContinueButtonTestId: 'survey-demographics-interstitial-continue',
  },
  [SurveyInterstitialRoute.MENTAL_PHYSICAL_HEALTH]: {
    heading: 'Next, we have some questions about your health.',
    additionalInfo:
      'We understand that topics like mental health may feel sensitive and want to remind you that your responses will be kept private and will only be used to provide support and resources to those in need.',
    interstitialContinueButtonTestId: 'survey-mental-physical-health-interstitial-continue',
  },
  [SurveyInterstitialRoute.BASIC_NEEDS]: {
    heading: "Now, we'll dive into whether your basic needs are being met.",
    additionalInfo:
      'We will use this information to provide you with customized recommendations to support you in any areas where you might need help.',
    interstitialContinueButtonTestId: 'survey-basic-needs-interstitial-continue',
  },
  [SurveyInterstitialRoute.ACADEMICS]: {
    heading:
      'For the next section, please answer each question considering only your experiences related to school and academics.',
    additionalInfo:
      'For example, for the question "In the last month, how often have you felt nervous or stressed" you would select the response that best describes how often you have felt nervous or stressed about school or your academic work.',
    interstitialContinueButtonTestId: 'survey-academics-interstitial-continue',
  },
  [SurveyInterstitialRoute.SOCIAL_FIT]: {
    heading:
      'For the final section, please indicate the extent to which you agree or disagree with each statement.',
    additionalInfo:
      'This section will ask questions about the extent to which you feel like you belong at your school.',
    interstitialContinueButtonTestId: 'survey-social-fit-interstitial-continue',
  },
} as const;
